export default "__VITE_ASSET__BflwyqYG__"